import { MouseEventHandler } from 'react'
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone'
import { Box, IconButton, SxProps } from '@mui/material'
import { grey } from '@mui/material/colors'

import { concatToSXProp } from 'utils/style'

import { Append as AppendProps } from '../interface'

interface RemoveButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  sx: SxProps
  border: AppendProps['border']
}

const style: SxProps = {
  marginRight: '11px',
  color: grey[500],
}

export default function RemoveButton({ onClick, sx, border }: RemoveButtonProps): JSX.Element {
  return (
    <Box
      className="append-remove-button"
      sx={concatToSXProp(sx, {
        background: 'inherit',
        borderRadius: '8px',
      })}
    >
      <IconButton
        onClick={onClick}
        size="small"
        sx={concatToSXProp(style, {
          marginTop: border ? '24px' : '16px',
          marginLeft: border ? 0 : '11px',
        })}
      >
        <DeleteOutlineTwoToneIcon />
      </IconButton>
    </Box>
  )
}
